import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Box, Button, CircularProgress } from "@mui/material";

const OVERLAY_STYLES = {
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 2,
  padding: 3,
  textAlign: "center",
} as const;

export function ClosingOverlay() {
  return (
    <Box sx={OVERLAY_STYLES}>
      <CircularProgress size={32} />
      <Box component="p" sx={{ fontWeight: 600, fontSize: "1rem", margin: 0 }}>
        Ending session...
      </Box>
      <Box component="p" sx={{ fontSize: "0.875rem", color: "text.secondary", margin: 0 }}>
        Cleaning up authentication
      </Box>
    </Box>
  );
}

interface ErrorOverlayProps {
  error: string;
  onRetry: () => void;
}

export function ErrorOverlay({ error, onRetry }: ErrorOverlayProps) {
  return (
    <Box sx={OVERLAY_STYLES}>
      <ErrorOutlineIcon sx={{ fontSize: 48, color: "error.main" }} />
      <Box component="p" sx={{ fontWeight: 600, fontSize: "1rem", color: "error.main", margin: 0 }}>
        Impersonation Failed
      </Box>
      <Box component="p" sx={{ fontSize: "0.875rem", color: "text.secondary", margin: 0 }}>
        {error}
      </Box>
      <Button
        variant="text"
        sx={{
          fontSize: "0.875rem",
          textDecoration: "underline",
        }}
        onClick={onRetry}
      >
        Retry
      </Button>
    </Box>
  );
}
